import { useState, useEffect } from "react";
import apiUrl from "../../Apiurl";
import stilePulsanti from "../../interfaccia/stilePulsanti";
import { useAuth0 } from "@auth0/auth0-react";
//import BrandVoceCliccabile from '../BrandVoceCliccabile';
import InputCodice from "../../inputs/InputCodice";

function ColonnaRicercaAvanzata({
  setListaProdottiBrand,
  setProductFunction,
  utente,
  switchaRicerca,
}) {
  const { user, /* isAuthenticated, */ getAccessTokenSilently } = useAuth0();
  const [token, setToken] = useState("");

  const {
    buttonClassesWhite,
    inputClassesNoMeasure,
    tastoQuadratoArrBianco,
    tastoChiudiAspetto,
  } = stilePulsanti;

  //const [listaBrand, setListaBrand] = useState([]);

  const [input, setInput] = useState({
    codiceVS: "",
    brand: "",
    shortName: "",
    codProdIntero: "",
  });

  useEffect(() => {
    const getUserMetadata = async () => {
      try {
        const accessToken = await getAccessTokenSilently();
        setToken(accessToken);
      } catch (e) {
        console.log(e.message);
      }
    };

    getUserMetadata();
  }, [getAccessTokenSilently, user?.sub]);

  const handleChange = async function (evt) {
    const value = evt.target.value;
    /* try {
            if (evt.target.name.includes(".")) {
                const update = _.set(_.cloneDeep(input), evt.target.name, value) // USO QUESTO METODO INVECE DI QUELLO SOPRA MA E' RESOURCE EXPENSIVE
                setInput(update)

            }
        } catch (err) {
            console.log("Errore nell'aggiornamento di un dato nestato: " + err)
            throw err;
        } */
    try {
      if (!evt.target.name.includes(".")) {
        setInput({
          ...input,
          [evt.target.name]: value,
        });
      }
    } catch (err) {
      console.log("Errore nell'aggiornamento di un dato non nestato: " + err);
      throw err;
    }
  };

  function ricerca(e) {
    e.preventDefault();
    fetch(
      apiUrl +
        "/prodotti/get/ricercaAvanzataNuoviCampi?" +
        new URLSearchParams(input),
      { headers: { Authorization: "Bearer " + token } }
    )
      .then((resp) => resp.json())
      .then((data) => {
        setListaProdottiBrand(data);
      });
  }

  return (
    <div className="">
      <div className="pa4 tc">
        <div className={tastoQuadratoArrBianco} onClick={switchaRicerca}>
          {tastoChiudiAspetto}
        </div>
      </div>
      <h2>Ricerca</h2>
      <form onSubmit={ricerca}>
        <label for="codiceVS">codice VS</label>
        <br />
        <input
          value={input.codiceVS}
          name="codiceVS"
          onChange={handleChange}
          id="codiceVS"
          className={inputClassesNoMeasure}
          type="text"
          aria-describedby="name-desc"
          autoComplete="off"
        />
        <br />
        <label for="shortName">Shortname</label>
        <br />
        <input
          value={input.shortName}
          name="shortName"
          onChange={handleChange}
          id="shortName"
          className={inputClassesNoMeasure}
          type="text"
          aria-describedby="name-desc"
          autoComplete="off"
        />
        <br />
        <label for="codProdIntero">Codice produttore</label>
        <br />
        <input
          value={input.codProdIntero}
          name="codProdIntero"
          onChange={handleChange}
          id="codProdIntero"
          className={inputClassesNoMeasure}
          type="text"
          aria-describedby="name-desc"
          autoComplete="off"
        />
        <br />
        <label for="brand">Produttore</label>
        <br />
        <input
          value={input.brand}
          name="brand"
          onChange={handleChange}
          id="brand"
          className={inputClassesNoMeasure}
          type="text"
          aria-describedby="name-desc"
          autoComplete="off"
        />
        <br />
        <br />
        <button className={buttonClassesWhite} onClick={ricerca}>
          Ricerca
        </button>
        <br />
        <br />
      </form>
      {utente.permessiAPI["post:database"] && (
        <div>
          <h2>Oppure crea nuovo</h2>
          <InputCodice
            setProductFunction={setProductFunction}
            showTasto={true}
            showLabels={true}
            showDescs={true}
            orientamento="verticale"
            utente={utente}
          />
        </div>
      )}
    </div>
  );
}

export default ColonnaRicercaAvanzata;
